import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { Height } from "@mui/icons-material";

const style = {
  position: "relative",
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-evenly",
  alignItems: "center",
  borderRadius: 30,
  border: "1px solid #1976d2",
  fontSize: 14,
  color: "#1976d2",
  width: 200,
  height: 40,
  padding: "1 0",
  "&:hover": {
    cursor: "pointer",
    backgroundColor: "#FAFAFA",
    opacity: "0.7",
  },
  "&>*:hover": {
    cursor: "pointer",
  },
  "&:active": {
    backgroundColor: "#EEEEEE",
  },
};

export default function QuickActionButton({
  icon,
  title,
  onClick,
  disabled = false,
}) {
  return (
    <Button startIcon={icon} onClick={onClick} disabled={disabled}>
      {title}
    </Button>
  );
}
